import Repository from './Repository'
const resource = '/addresses'

export default {
  /**
   * 都道府県リストを取得する
   * @param {Number} filter 店舗設定による都道府県のフィルター 0:無効 1:有効
   */
  async getPrefs(filter) {
    const params = { filter: filter }
    return await Repository.get(`${resource}/prefs`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 市区リストを取得する
   * @param {Array} prefCds 都道府県コード
   */
  async getShikus(prefCds) {
    const params = { pref_cds: prefCds }
    return await Repository.get(`${resource}/shikus`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 町村リストを取得する
   * @param {Array} cds 沿線コード
   */
  async getChosons(cds) {
    const params = { cds: cds }
    return await Repository.get(`${resource}/chosons`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 丁目リストを取得する
   * @param {Array} cds 沿線コード
   */
  async getAzas(cds) {
    const params = { cds: cds }
    return await Repository.get(`${resource}/azas`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
